export const calculateBmi = ({ heightInCms, weightInKgs }: { heightInCms: number; weightInKgs: number }) => {
    const heightInMetres = heightInCms / 100;
    return (weightInKgs / heightInMetres / heightInMetres).toFixed(2);
};
